<template>
  <hm-content title>
    <div class>
      <el-input
        placeholder="输入版本/名称/描述"
        size="small"
        v-model="filterText"
        @input="filterList"
      ></el-input>
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="草稿箱" name="templatedraft">
          <el-table
            stripe
            ref="roleTable"
            :data="draftListResult"
            style="width: 100%"
            id="table"
            size="small"
            border
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="编号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="user_version"
              label="版本号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="source_miniprogram"
              label="来源小程序"
            ></el-table-column>
            <el-table-column
              header-align="center"
              show-overflow-tooltip
              align="center"
              prop="user_desc"
              label="描述"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="developer"
              label="最近上传开发者"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="createTimeFormat"
              label="最近提交时间"
            ></el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="addTotemp(scope.row)"
                  >添加到模板库</el-button
                >
                <!-- <el-button type="text" size="small" @click="remove(scope.row)"
                  >删除</el-button
                >-->
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="小程序模板库" name="template">
          <el-table
            stripe
            ref="roleTable"
            :data="tempListResult"
            style="width: 100%"
            id="table"
            size="small"
            border
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="编号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="user_version"
              label="版本号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="source_miniprogram"
              label="来源小程序"
            ></el-table-column>
            <el-table-column
              header-align="center"
              show-overflow-tooltip
              align="center"
              prop="user_desc"
              label="描述"
            ></el-table-column>
            <!-- <el-table-column header-align="center" align="center" prop="template_id" label="模板ID"></el-table-column> -->
            <el-table-column
              header-align="center"
              align="center"
              prop="createTimeFormat"
              label="添加到模板库时间"
            ></el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="submit(scope.row)"
                  >上传</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="submit(scope.row, 'store')"
                  >上传商城模板</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="submit(scope.row, 'live')"
                  >上传直播模板</el-button
                >
                <el-button type="text" size="small" @click="remove(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </hm-content>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      tempListResult: [],
      draftListResult: [],
      filterText: "",
      activeTab: "templatedraft",
      draftList: [],
      tempList: []
    };
  },
  computed: {},
  watch: {},
  created() {
    // 查询草稿
    this.queryMpTemp("templatedraft");
  },
  mounted() {},
  methods: {
    filterList() {
      switch (this.activeTab) {
        case "templatedraft":
          this.filterFunc("draftList");
          break;
        case "template":
          this.filterFunc("tempList");
          break;
        default:
          break;
      }
    },
    handleClick() {
      this.queryMpTemp(this.activeTab);
    },
    async queryMpTemp(type) {
      const { result } = await this.$store.dispatch("queryMpTemp", {
        type
      });
      if (type === "templatedraft") {
        result.draft_list.forEach(v => {
          v.createTimeFormat = moment(v.create_time * 1000).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        });
        this.draftList = result.draft_list.sort(function(a, b){return b.create_time - a.create_time}) || [];
        this.filterFunc("draftList");
      } else {
        result.template_list.forEach(v => {
          v.createTimeFormat = moment(v.create_time * 1000).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        });
        this.tempList = result.template_list.sort(function(a, b){return b.create_time - a.create_time}) || [];
        this.filterFunc("tempList");
      }
    },
    filterFunc(originData) {
      this[originData + "Result"] = this[originData].filter(v => {
        return (
          v.user_version.indexOf(this.filterText) > -1 ||
          v.source_miniprogram.indexOf(this.filterText) > -1 ||
          v.user_desc.indexOf(this.filterText) > -1
        );
      });
    },
    async addTotemp(row) {
      const { code } = await this.$store.dispatch("addMpTemp", {
        draftId: row.draft_id
      });
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
      }
    },
    submit(row, type) {
      if (type) {
        this.$confirm("确定上传当前版本?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.commitMpTemp(row, type);
        });
      } else {
        this.commitMpTemp(row, type);
      }
    },
    commitMpTemp(row, type) {
      this.$store
        .dispatch("commitMpTemp", {
          authorizerAppids: type ? [] : [row.source_miniprogram_appid],
          templateId: row.template_id,
          userVersion: row.user_version,
          userDesc: row.user_desc,
          isLive: type !== "live" ? 0 : 1
        })
        .then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryMpTemp("template");
          }
        });
    },
    remove(row) {
      // this.$confirm(" 删除本行数据?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // }).then(() => {
      this.$store
        .dispatch("deleteMpTemp", {
          templateId: row.template_id
        })
        .then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryMpTemp("template");
          }
        });
      // });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
